import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { SettingsService } from '../services/settings.service';
import { PlatformService } from '../services/ssr/platform.service';
import { VendorsService } from '../services/vendors.service';

@Injectable({ providedIn: 'root' })
export class BrowserHomePageGuard implements CanActivate {
  constructor(
    private router: Router,
    private vendorsService: VendorsService,
    private settingsService: SettingsService,
    private platformService: PlatformService,
  ) {}

  canActivate() {
    if (this.platformService.isCordova || !!this.vendorsService.getAddressSearchFilters()) {
      const currentOrDefaultCountryCode = this.settingsService.getCountry().code;
      const currentOrDefaultLanguageCode = this.settingsService.getLanguage().value;
      return this.router.createUrlTree([`/${currentOrDefaultCountryCode}/${currentOrDefaultLanguageCode}/vendors`]);
    }

    return true;
  }
}
